<template>
  <div class="base">
    <inside-header color="#fff" title="手机设置" />
    <div class="main">
      <div v-show="step === 'first'" class="first-step">
        <a-alert message="您好，您正在绑定手机。平台将向您输入的号发送验证码，请在下一步中填写验证码验证" banner />
        <a-form :form="phoneForm" :label-col="{ span: 5 }" style="margin-top: 40px;" :wrapper-col="{ span: 18 }"
          @submit="handleGetPhoneCode">
          <a-form-item label="手机号码">
            <a-input v-decorator="[
              'phone',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入您的手机号'
                  },
                  {
                    pattern: /^1[3-9][0-9]\d{8}$/,
                    message: '请输入正确的手机号码'
                  }
                ]
              }
            ]" placeholder="输入您的手机号码" />
          </a-form-item>
          <a-form-item label="验证码">
            <a-row :gutter="16">
              <a-col :span="16">
                <a-input v-decorator="[
                  'captcha_value',
                  { rules: [{ required: true, message: '请输入图形验证码' }] }
                ]" size="large" placeholder="图形验证码" />
              </a-col>
              <a-col :span="8">
                <img style="cursor: pointer" width="80px" height="100%" :src="captcha_img_str" alt=""
                  @click="loadVerify">
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" :loading="state.getPhoneCodeBtn" html-type="submit">
              下一步
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <div v-show="step === 'second'" class="second-step">
        <a-alert message="查收平台下发邮箱的邮件，将验证码复制到输入框进行验证" banner />
        <a-form :form="phoneVerifyForm" :label-col="{ span: 5 }" style="margin-top: 40px;" :wrapper-col="{ span: 18 }"
          @submit="handleSubmitPhoneVerify">
          <a-form-item label="验证码">
            <a-input v-decorator="[
              'phone_captcha_code',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入您的手机验证码'
                  }
                ]
              }
            ]" placeholder="输入您的手机验证码" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" :loading="state.verifyPhoneBtn" html-type="submit">
              提交
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'

export default {
  name: 'UserSetting',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
      loading: false,
      state: {
        getPhoneCodeBtn: false,
        verifyPhoneBtn: false
      },
      // 验证码
      captcha_key: '',
      captcha_img_str: '',
      phoneForm: this.$form.createForm(this, { name: 'get-phone-code-form' }),
      phoneVerifyForm: this.$form.createForm(this, {
        name: 'phone-verify-form'
      }),
      step: 'first'
    }
  },
  created() {
    this.loadVerify()
  },
  methods: {
    loadVerify() {
      // 调用删除
      this.$http({
        url: '/index/index/captcha',
        method: 'get'
      }).then(res => {
        if (res.status === 'success') {
          this.captcha_key = res.data.captcha_key
          this.captcha_img_str = res.data.img_str
        } else {
          this.$notification.error({
            message: '错误',
            description: '获取验证码失败'
          })
        }
      })
    },
    handleGetPhoneCode(e) {
      e.preventDefault()
      this.phoneForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.state.getPhoneCodeBtn = true
          values.captcha_key = this.captcha_key
          this.$http({
            url: '/index/phone/unbindPhoneCode',
            method: 'post',
            data: values
          }).then(res => {
            this.state.getPhoneCodeBtn = false
            if (res.status === 'success') {
              this.$toast.success('发送短信验证码成功')
              this.step = 'second'
            } else {
              this.$toast.fail(res.message)
            }
          })
        }
      })
    },
    handleSubmitPhoneVerify(e) {
      e.preventDefault()
      this.phoneVerifyForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.state.verifyPhoneBtn = true
          const phone = this.phoneForm.getFieldValue('phone')
          values.phone = phone
          this.$http({
            url: '/index/phone/verifyPhoneCodeToBind',
            method: 'post',
            data: values
          }).then(res => {
            this.state.verifyPhoneBtn = false
            if (res.status === 'success') {
              this.$toast.success('绑定手机成功')
              this.visiblePhoneDrawer = false
              this.visibleVerifyPhoneCodeDrawer = false
              // 返回上一页
              this.$router.go(-1)
            } else {
              this.$toast.fail(res.message)
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.base {
  min-width: 280px;
  max-width: 420px;
  margin: auto;
  background-color: #fff;
}

.main {
  padding: 15px;
}

.logout-btn {
  margin-top: 20px;
  .van-button__content {
    span {
      color: #333333;
    }
  }
}

.submit-area {
  margin-top: 35px;
  .submit-btn {
    border-radius: 10px;
  }
}
</style>
